import { render } from "./user-reference-books.vue?vue&type=template&id=2ff7cbba"
import script from "./user-reference-books.vue?vue&type=script&setup=true&lang=js"
export * from "./user-reference-books.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/nsi/user-reference-books/user-reference-books.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2ff7cbba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2ff7cbba', __exports__)) {
    api.reload('2ff7cbba', __exports__)
  }
  
  module.hot.accept("./user-reference-books.vue?vue&type=template&id=2ff7cbba", () => {
    api.rerender('2ff7cbba', render)
  })

}


export default __exports__